import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './added-column.module.css';

interface AddedColumnProps {
    date: ReactNode;
    actions?: ReactNode;
    isAccordionOpen?: boolean;
}

export function AddedColumn({ date, actions, isAccordionOpen }: AddedColumnProps) {
    if (!actions) {
        return (
            <span className={classNames('added-column__date', styles['added-column__date'])}>
                {date}
            </span>
        );
    }

    return (
        <div
            className={classNames('added-column', styles['added-column'], {
                'added-column--accordion-open': isAccordionOpen,
                [styles['added-column--accordion-open']]: isAccordionOpen,
            })}
        >
            <span className={classNames('added-column__date', styles['added-column__date'])}>{date}</span>
            <div className={classNames('added-column__actions', styles['added-column__actions'])}>{actions}</div>
        </div>
    );
}
